import { Link } from 'react-router-dom';
import styled from 'styled-components'
import { mainColor, mainFont } from '../../styles/global';

export const Container = styled.div`
    padding:3% 10%;
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap:1rem;
    div{
        display:flex;
        justify-content: center;
        align-items: center;
        margin-top:40px;
        img{
            height:100%;
            width:80%;
        }
    }
    >h3{ 
        font-family: ${mainFont};
        font-style: normal;
        font-size: 64px;
        line-height: 58px;
        letter-spacing: 0.01em;
        color: #008080;
    }
    p{
        font-family: ${mainFont};
        font-style: normal;
        font-weight: 500;
        font-size: 36px;
        line-height: 58px;
        text-align: justify;
        letter-spacing: 0.01em;
        color:${mainColor};
    }

    @media screen and (max-width: 768px) {
        
        h3{
            font-size: 30px;
            line-height: 30px;
        }
        p{
            font-size: 15px;
            line-height: 18px;
            letter-spacing: 0.01em;
        }
    }

`;


export const NavLink = styled(Link)`
    background:${mainColor};
    color:#fff;
    text-decoration:none;
    padding:15px 20px;
    margin-bottom:20px;
    border-radius:9px;
`;